import React from 'react';
import { AppWidgetProps } from '../../../types/common';
import Restricted from '../../PackagePicker/Widget/Restricted';

export const PaywallWidget: React.FC<AppWidgetProps> = (props) => {
  return <Restricted {...props} />;
};
